import { isPrerenderOld } from '@df/core/service/client';

let gtmAwaiters = 0;
export const gtmAwait = (cb: (done: () => void) => void | any) => {
    let finished = false;
    const done = () => {
        if (!finished) {
            finished = true;
            gtmAwaiters--;
            if (!gtmAwaiters) {
                gtmActivate();
            }
        }
    };
    gtmAwaiters++;
    cb(done);
};

gtmAwait(done => setTimeout(done, 200));

function gtmActivate() {
    const config = typeof window !== 'undefined' && window.dfConfig.gtm;
    if (config && !isPrerenderOld && typeof window !== 'undefined') {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });

            const f = d.getElementsByTagName(s)[0];
            const j = <any>d.createElement(s);
            const dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                '//www.googletagmanager.com/gtm.js?id=' +
                config.id +
                dl +
                '&gtm_auth=' +
                (config.auth || '') +
                '&gtm_preview=' +
                (config.env || '') +
                '&gtm_cookies_win=x';
            if (f.parentNode) {
                f.parentNode.insertBefore(j, f);
            }
        })(window, document, 'script', 'dataLayer');
    }
}
